<template>
    <DCard
        padding
    >
        <Form
            :product-plan="productPlan"
            :billing-cycles="billingCycles"
            :contract-term-units="contractTermUnits"
            :discount-types="discountTypes"
            :product-id="productId"
            :errors="errors"
            :is-addon="true"
            :currency="currency"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Products/ProductPrices/Form'
import { route } from '~@/Composables/route'

const props = defineProps({
    productId: {
        type: Number,
        default: 0
    },
    productPlan: {
        type: Object,
        default () {
            return {}
        }
    },
    billingCycles: {
        type: Array,
        default () {
            return []
        }
    },
    contractTermUnits: {
        type: Array,
        default () {
            return []
        }
    },
    discountTypes: {
        type: Array,
        default () {
            return []
        }
    },
    currency: {
        type: String,
        default: null
    },
    errors: {
        type: Object,
        default () {
            return {}
        }
    }
})

function submitData (form) {
    form.post(route('products.product-addons.products.plans.prices.store', {
        product: props.productId,
        plan: props.productPlan
    }
    ))
}

</script>
